module.exports = __webpack_public_path__ + "img/Format-presentations.eedd98b8.svg";